/*
  ========================================================================
  File: assets/lm-colour-groups.js - the Colour filter's base colours
        (module lm-collection)
  LAST UPDATED: 26/09/2026
  ========================================================================
  Loaded as a module by snippets/lm-colour-groups.liquid wherever the
  grouped Colour filter renders (collection pages and search), so it runs
  once per page however often Prestige re-renders the filters.

  Each base colour (Red) is a checkbox without a name, followed by hidden
  checkboxes for the colour names it covers (Affair, Cherry, Wine, ...),
  which are what the filter URL carries. Ticking or clearing the base
  colour ticks or clears all of them. Capture phase on document, so this
  runs before Prestige's facets-form reads the form on "change".
  ========================================================================
*/

document.addEventListener('change', (event) => {
  const group = event.target;
  if (!(group instanceof HTMLInputElement) || !group.hasAttribute('data-lm-colour-group')) return;

  group.closest('.lm-colour-group')?.querySelectorAll('input[data-lm-colour-member]').forEach((member) => {
    member.checked = group.checked;
  });
}, true);
